export const SIGN_OUT_REQUEST = 'auth/SIGN_OUT_REQUEST';
export const SIGN_OUT_SUCCESS = 'auth/SIGN_OUT_SUCCESS';
export const SIGN_OUT_FAILURE = 'auth/SIGN_OUT_FAILURE';

export const SET_AUTH_REQUEST = 'auth/SET_AUTH_REQUEST';
export const SET_AUTH_SUCCESS = 'auth/SET_AUTH_SUCCESS';
export const SET_AUTH_FAILURE = 'auth/SET_AUTH_FAILURE';

export const CLEAR_AUTH_ERROR = 'auth/CLEAR_AUTH_ERROR';

export const SET_ACCESSIBLE_SCHOOL_IDS = 'auth/SET_ACCESSIBLE_SCHOOL_IDS';

export const signOutRequest = (payload = {}) => ({
  type: SIGN_OUT_REQUEST,
  payload,
});
export const signOutSuccess = (payload = {}) => ({
  type: SIGN_OUT_SUCCESS,
  payload,
});
export const signOutFailure = (payload = {}) => ({
  type: SIGN_OUT_FAILURE,
  payload,
});

export const setAuthRequest = (payload = {}) => ({
  type: SET_AUTH_REQUEST,
  payload,
});
export const setAuthSuccess = (payload = {}) => ({
  type: SET_AUTH_SUCCESS,
  payload,
});
export const setAuthFailure = (payload = {}) => ({
  type: SET_AUTH_FAILURE,
  payload,
});

export const clearAuthError = () => ({
  type: CLEAR_AUTH_ERROR,
});

export const setAccessibleSchoolIds = (payload = {}) => ({
  type: SET_ACCESSIBLE_SCHOOL_IDS,
  payload,
});
